import { render } from "./BetaSignupForm.vue?vue&type=template&id=3541b99a"
import script from "./BetaSignupForm.vue?vue&type=script&lang=js"
export * from "./BetaSignupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__